'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SVGTextStyle = require('./SVGTextStyle');

var _SVGTextStyle2 = _interopRequireDefault(_SVGTextStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents2.default)(_SVGTextStyle2.default).withConfig({
  displayName: 'SVGTextIconStyle'
})(['font-family:\'spacesword\' !important;font-feature-settings:\'liga\';font-size:110%;font-variant:normal;font-weight:normal !important;letter-spacing:0;text-transform:none;']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/UIAvatarDisplay/baseStyledComponents/SVGTextIconStyle.js
// module id = 191
// module chunks = 177